/* tslint:disable */
/* eslint-disable */
/**
 * UserManage API
 * ユーザー関連の操作
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * ユーザー一覧情報取得成功時のレスポンス情報
 * @export
 * @interface GetUserSuccessResponseInfo
 */
export interface GetUserSuccessResponseInfo {
    /**
     * 
     * @type {number}
     * @memberof GetUserSuccessResponseInfo
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetUserSuccessResponseInfo
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetUserSuccessResponseInfo
     */
    'message': string;
    /**
     * 
     * @type {GetUserSuccessResponseInfoAllOfResult}
     * @memberof GetUserSuccessResponseInfo
     */
    'result': GetUserSuccessResponseInfoAllOfResult;
}
/**
 * 
 * @export
 * @interface GetUserSuccessResponseInfoAllOfResult
 */
export interface GetUserSuccessResponseInfoAllOfResult {
    /**
     * 
     * @type {Array<UserInfo>}
     * @memberof GetUserSuccessResponseInfoAllOfResult
     */
    'data': Array<UserInfo>;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * ユーザーID
     * @type {string}
     * @memberof UserInfo
     */
    'userId': string;
    /**
     * ユーザーの名称
     * @type {string}
     * @memberof UserInfo
     */
    'userName': string;
    /**
     * ユーザーの権限
     * @type {string}
     * @memberof UserInfo
     */
    'userRole': string;
}

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 組織内のユーザー一覧を取得する
         * @param {string} [keyWord] ユーザー名検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 組織内のユーザー一覧を取得する
         * @param {string} [keyWord] ユーザー名検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserSuccessResponseInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary 組織内のユーザー一覧を取得する
         * @param {string} [keyWord] ユーザー名検索キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(keyWord?: string, options?: any): AxiosPromise<GetUserSuccessResponseInfo> {
            return localVarFp.getUser(keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary 組織内のユーザー一覧を取得する
     * @param {string} [keyWord] ユーザー名検索キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUser(keyWord?: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUser(keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



